import React, { Component } from 'react';
//import './backdrop.css';

const backdrop = props => (
    <div className="backdrop" onClick={props.backdropClickHandler} onKeyDown={(e) => { if (e.key === 'Escape') props.backdropClickHandler(); }} role="button" tabIndex="-1" aria-label="Close menu">
    </div>
);
           
export default backdrop;